{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "Apply",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "LAST_7_DAYS": "Síðustu 7 daga",
      "LAST_30_DAYS": "Síðustu 30 daga",
      "LAST_3_MONTHS": "Síðustu 3 mánuði",
      "LAST_6_MONTHS": "Síðustu 6 mánuði",
      "LAST_YEAR": "Síðasta ár",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "This month",
      "CUSTOM_RANGE": "Custom date range"
    }
  }
}
